/*!
 * Copyright 2023 Thorne Health Lab. All rights reserved.
 */
import React from 'react'
import { SymmetrySetup } from './d3-charts/symmetry-chart'

class SymmetryChart extends React.Component {
  constructor(props) {
    super(props)

    // getinitialState
    this.state = {
      initData: props.data
    }
  }

  componentDidMount() {
    const _this = this
    const { label } = this.props

    const settings = {
      el: 'chart' + label,
      margin: { top: 0, right: 0, bottom: 0, left: 0 }
    }

    const chart = new SymmetrySetup()
    chart.create(_this.state.initData, settings).then(function() {
      chart.update(_this.state.initData)
    })
  }

  render() {
    const { label } = this.props

    return (
      <div className="sym-chart chart-wrapper">
        <div id={'chart' + label} className="symmetryChart" />
      </div>
    )
  }
}

export default SymmetryChart
